"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _react = _interopRequireWildcard(require("react"));

var _withStyles = _interopRequireDefault(require("elevate-ui/withStyles"));

var _reactBeautifulDnd = require("react-beautiful-dnd");

var _classnames = _interopRequireDefault(require("classnames"));

var _RenderContent = _interopRequireDefault(require("../../../Internals/RenderContent"));

var _Placeholder = _interopRequireDefault(require("../../Row/Placeholder"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var getColor = function getColor(color) {
  switch ((0, _typeof2["default"])(color)) {
    case "object":
      return "rgba(".concat(color.r, ", ").concat(color.g, ", ").concat(color.b, ", ").concat(color.a, ")");

    default:
      return color || "transparent";
  }
};

var getItemStyle = function getItemStyle(isDragging, draggableStyle, child) {
  return _objectSpread({
    // some basic styles to make the items look a bit nicer
    userSelect: "none",
    // change background colour if dragging
    background: isDragging ? "lightgreen" : "transparent",
    width: child && child.attrs && child.attrs.width
  }, draggableStyle);
};

var getHoverStyle = function getHoverStyle(isDraggingOver) {
  return {
    background: isDraggingOver ? "lightblue" : "transparent",
    width: "100%"
  };
};

var WrapperPreview = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(WrapperPreview, _Component);

  var _super = _createSuper(WrapperPreview);

  function WrapperPreview() {
    (0, _classCallCheck2["default"])(this, WrapperPreview);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(WrapperPreview, [{
    key: "renderChildren",
    value: function renderChildren() {
      var _this$props = this.props,
          classes = _this$props.classes,
          parent = _this$props.content,
          _this$props$content = _this$props.content,
          content = _this$props$content.content,
          id = _this$props$content.id,
          internals = _this$props.internals;
      var isActive = internals.editingContentId === id;

      if (!(content && content.length)) {
        if (!(internals.isEditor || internals.previewPlaceholders)) {
          return null;
        }

        return /*#__PURE__*/_react["default"].createElement(_Placeholder["default"], {
          onClick: function onClick(e) {
            e.stopPropagation();
            internals.addChildToContent(id);
          }
        });
      }

      return content.map(function (child, idx) {
        if (!child) {
          return null;
        }

        var renderedChild = /*#__PURE__*/_react["default"].createElement(_RenderContent["default"], {
          key: idx,
          internals: internals,
          content: [child],
          parent: parent
        });

        if (!isActive || content.length === 1) {
          // content === 1 check because we don't want to show something as draggable when there are no other siblings to sort against
          return renderedChild;
        }

        return /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.Draggable, {
          key: child.id,
          draggableId: child.id,
          index: idx
        }, function (provided, snapshot) {
          return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
            ref: provided.innerRef
          }, provided.draggableProps, provided.dragHandleProps, {
            style: getItemStyle(snapshot.isDragging, provided.draggableProps.style, child),
            className: classes.draggable
          }), renderedChild);
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          classes = _this$props2.classes,
          _this$props2$content = _this$props2.content,
          attrs = _this$props2$content.attrs,
          id = _this$props2$content.id,
          _this$props2$internal = _this$props2.internals,
          editingContentId = _this$props2$internal.editingContentId,
          isEditor = _this$props2$internal.isEditor,
          previewPlaceholders = _this$props2$internal.previewPlaceholders,
          refCallback = _this$props2.refCallback;

      if (isEditor || previewPlaceholders) {
        var isActive = editingContentId === id;

        var row = /*#__PURE__*/_react["default"].createElement("div", {
          className: classes.container,
          ref: refCallback
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: classes.innerContainer
        }, this.renderChildren()), attrs.footer && /*#__PURE__*/_react["default"].createElement("div", {
          className: classes.footer
        }, attrs.footer));

        if (!isActive) {
          return row;
        }

        return /*#__PURE__*/_react["default"].createElement("div", {
          className: (0, _classnames["default"])(classes.root)
        }, /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.Droppable, {
          droppableId: id,
          direction: attrs.direction || "vertical"
        }, function (provided, snapshot) {
          return /*#__PURE__*/_react["default"].createElement("div", {
            ref: provided.innerRef,
            style: getHoverStyle(snapshot.isDraggingOver)
          }, row);
        }));
      }

      return /*#__PURE__*/_react["default"].createElement("table", (0, _extends2["default"])({
        className: classes.tableWrapper
      }, this.wrapperAttrs()), /*#__PURE__*/_react["default"].createElement("tbody", null, /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
        className: classes.tdWrapper
      }, /*#__PURE__*/_react["default"].createElement("table", (0, _extends2["default"])({}, this.innerAttrs(), {
        className: classes.innerContainerTable
      }), /*#__PURE__*/_react["default"].createElement("tbody", null, /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", null, this.renderChildren())))))), attrs.footer && /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
        className: classes.footer
      }, attrs.footer))));
    }
  }, {
    key: "innerAttrs",
    value: function innerAttrs() {
      var attrs = this.props.content.attrs;
      return {
        width: "".concat(attrs.width, "px"),
        bgcolor: attrs.innerBackgroundColor,
        border: "0",
        cellSpacing: "0",
        cellPadding: "0"
      };
    }
  }, {
    key: "wrapperAttrs",
    value: function wrapperAttrs() {
      var attrs = this.props.content.attrs;
      return {
        width: "100%",
        bgcolor: attrs.backgroundColor,
        border: "0",
        cellSpacing: "0",
        cellPadding: "0"
      };
    }
  }]);
  return WrapperPreview;
}(_react.Component);

var _default = (0, _withStyles["default"])(function (theme) {
  return {
    root: {
      display: "flex",
      width: function width(_ref) {
        var attrs = _ref.content.attrs,
            isEditor = _ref.internals.isEditor;
        return !isEditor && attrs && (attrs.width || "") !== "" && "100%";
      },
      minHeight: function minHeight(_ref2) {
        var attrs = _ref2.content.attrs;
        return attrs && attrs.height;
      }
    },
    tableWrapper: {
      backgroundColor: function backgroundColor(_ref3) {
        var attrs = _ref3.content.attrs;
        return attrs.backgroundColor;
      },
      textSizeAdjust: "100%",
      "@media only screen and (max-width: 675px)": {
        width: "100% !important",
        tableLayout: "auto !important"
      },
      fontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', Arial, sans-serif",
      fontWeight: "400"
    },
    tdWrapper: {
      paddingTop: function paddingTop(_ref4) {
        var attrs = _ref4.content.attrs;
        return attrs.paddingTop ? "".concat(attrs.paddingTop, "px") : "0";
      },
      paddingRight: function paddingRight(_ref5) {
        var attrs = _ref5.content.attrs;
        return attrs.paddingRight ? "".concat(attrs.paddingRight, "px") : "0";
      },
      paddingBottom: function paddingBottom(_ref6) {
        var attrs = _ref6.content.attrs;
        return attrs.paddingBottom ? "".concat(attrs.paddingBottom, "px") : "0";
      },
      paddingLeft: function paddingLeft(_ref7) {
        var attrs = _ref7.content.attrs;
        return attrs.paddingLeft ? "".concat(attrs.paddingLeft, "px") : "0";
      }
    },
    footer: {
      textAlign: "center",
      paddingTop: function paddingTop(_ref8) {
        var attrs = _ref8.content.attrs,
            isEditor = _ref8.internals.isEditor;
        return isEditor && attrs.paddingBottom ? "".concat(attrs.paddingBottom, "px") : "0";
      },
      paddingBottom: function paddingBottom(_ref9) {
        var attrs = _ref9.content.attrs,
            isEditor = _ref9.internals.isEditor;
        return !isEditor && attrs.paddingBottom ? "".concat(attrs.paddingBottom, "px") : "0";
      }
    },
    innerContainerTable: {
      margin: "0 auto",
      width: function width(_ref10) {
        var attrs = _ref10.content.attrs;
        return attrs && "".concat(attrs.width, "px");
      },
      tableLayout: "fixed",
      border: function border(_ref11) {
        var attrs = _ref11.content.attrs;
        return attrs.borderSize > 0 ? "".concat(attrs.borderSize, "px solid ").concat(getColor(attrs.borderColor)) : null;
      },
      backgroundColor: function backgroundColor(_ref12) {
        var attrs = _ref12.content.attrs;
        return getColor(attrs.innerBackgroundColor);
      },
      "@media only screen and (max-width: 675px)": {
        width: "auto !important",
        tableLayout: "auto !important"
      }
    },
    innerContainer: {
      width: function width(_ref13) {
        var attrs = _ref13.content.attrs;
        return attrs && "".concat(attrs.width, "px");
      },
      border: function border(_ref14) {
        var attrs = _ref14.content.attrs;
        return attrs.borderSize > 0 ? "".concat(attrs.borderSize, "px solid ").concat(getColor(attrs.borderColor)) : null;
      },
      backgroundColor: function backgroundColor(_ref15) {
        var attrs = _ref15.content.attrs;
        return getColor(attrs.innerBackgroundColor);
      }
    },
    container: {
      display: "flex",
      flexWrap: "nowrap",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      fontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', Arial, sans-serif",
      fontWeight: "500",
      minWidth: function minWidth(_ref16) {
        var attrs = _ref16.content.attrs;
        return "".concat(675 + attrs.paddingLeft + attrs.paddingRight, "px");
      },
      flexDirection: "column",
      backgroundColor: function backgroundColor(_ref17) {
        var attrs = _ref17.content.attrs;
        return getColor(attrs.backgroundColor);
      },
      paddingTop: function paddingTop(_ref18) {
        var attrs = _ref18.content.attrs;
        return attrs.paddingTop ? "".concat(attrs.paddingTop, "px") : "0";
      },
      paddingRight: function paddingRight(_ref19) {
        var attrs = _ref19.content.attrs;
        return attrs.paddingRight ? "".concat(attrs.paddingRight, "px") : "0";
      },
      paddingBottom: function paddingBottom(_ref20) {
        var attrs = _ref20.content.attrs;
        return attrs.paddingBottom ? "".concat(attrs.paddingBottom, "px") : "0";
      },
      paddingLeft: function paddingLeft(_ref21) {
        var attrs = _ref21.content.attrs;
        return attrs.paddingLeft ? "".concat(attrs.paddingLeft, "px") : "0";
      }
    },
    draggable: {
      alignItems: "center",
      // margin: "2px",
      "& > *": {
        width: "100% !important"
      }
    }
  };
})(WrapperPreview);

exports["default"] = _default;